module.exports = __webpack_public_path__ + "img/revoked.2813120d.svg";